import {PagesArchitecture} from "../constants/page/pagesArchitecture"
import {NOT_FOUND_ROUTE, SIMPLE_ROUTES} from "../constants/routes"
import {buildSimpleRoutesFromConfig} from "../shared-components/utils/buildRoutesUtil"

export const buildMainLayoutRoutes = () => [
    ...buildSimpleRoutesFromConfig(PagesArchitecture, SIMPLE_ROUTES),
    ...buildSimpleRoutesFromConfig(PagesArchitecture, [NOT_FOUND_ROUTE]),
]
